export enum PlatformInfoBannerVariant {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
}

export interface PlatformInfoBannerSettingsResponseDto {
  enabled: boolean;
  variant: PlatformInfoBannerVariant;
  title: string;
  content: string;
  updatedAt?: string | null;
}

export interface UpdatePlatformInfoBannerSettingsRequestDto {
  enabled: boolean;
  variant: PlatformInfoBannerVariant;
  title?: string;
  content?: string;
}
